import { Component, OnInit } from '@angular/core';
import { SocialComment } from '../../interface/SocialCommentInterface';
import { SocialCommentService } from '../../services/SocialCommentService';
import { SseService } from '../../services/SseService';

@Component({
  selector: 'app-social-comments',
  templateUrl: './social-comments.component.html',
  styleUrls: ['./social-comments.component.scss']
})
export class SocialCommentsComponent implements OnInit {

  comments: SocialComment[] = [];
  loading = false;

  expandedIndex: number | null = null;

  // =========================
  // REPLY STATE (SIMPLE Y GLOBAL)
  // =========================
  replyTarget: any = null;
  replyMessage: string = '';

  userId = 615;
  showDeleteDialog = false;
  deleteTarget: any = null;

  readonly networkLabels: { [key: string]: string } = {
    INSTAGRAM: 'Instagram',
    FACEBOOK: 'Facebook',
    LINKEDIN: 'LinkedIn',
    TWITTER: 'Twitter',
    YOUTUBE: 'YouTube'
  };

  constructor(
    private socialCommentService: SocialCommentService,
    private sseService: SseService,
  ) {}

  ngOnInit(): void {
    this.loadComments();
  }

  // =========================
  // LOAD DATA
  // =========================
  loadComments(): void {
    this.loading = true;
    this.sseService.apiGetWithAuth('social/comments?network=TWITTER',this.sseService.licencia)
                .subscribe({
                  next: () => {


                  },
                  error: (err) => {
                    console.error('Error sincronizando comentarios YouTube',err);

                  }

                });
  }

  // =========================
  // EXPANDIR REPLIES
  // =========================
  toggle(i: number) {
    this.expandedIndex = this.expandedIndex === i ? null : i;
  }

  // =========================
  // RESPONDER A COMMENT
  // =========================
  openReply(comment: any, event: Event) {
    event.stopPropagation();

    this.replyTarget = comment;
  }

  // =========================
  // RESPONDER A REPLY
  // =========================
  openReplyToChild(reply: any, event: Event) {
    event.stopPropagation();

    this.replyTarget = reply;
  }

  // =========================
  // ENVIAR RESPUESTA (UNIFICADO)
  // =========================
  sendReply() {

    if (!this.replyTarget) return;

    const payload = {
      network: this.replyTarget.network,
      commentId: this.replyTarget.externalId,
      message: this.replyMessage
    };

    this.socialCommentService.replyToComment(payload, this.userId)
      .subscribe({
        next: () => {

          this.replyMessage = '';
          this.replyTarget = null;

          this.loadComments(); // refrescar árbol completo
        },
        error: (err) => {
          console.error('Error enviando respuesta', err);
        }
      });
  }
 /*  deleteComment(comment: any,  event: Event) {
    event.stopPropagation();
    const payload = {
      network: comment.network,
      commentId: comment.externalId
    };

    this.socialCommentService.deleteComment(payload, this.userId)
      .subscribe({
        next: () => {

          console.log('Comentario eliminado');

          this.loadComments();

        },
        error: (err) => {
          console.error('Error eliminando comentario', err);
        }
      });
  } */
 deleteComment(comment: any, event: Event) {
  event.stopPropagation();

  this.deleteTarget = comment;
  this.showDeleteDialog = true;
}
confirmDelete() {

  if (!this.deleteTarget) return;

  const payload = {
    network: this.deleteTarget.network,
    commentId: this.deleteTarget.externalId
  };
 console.log(payload);
  this.socialCommentService.deleteComment(payload, this.userId)
    .subscribe({
      next: () => {

        console.log('Comentario eliminado');

        this.showDeleteDialog = false;
        this.deleteTarget = null;

        this.loadComments();

      },
      error: (err) => {
        console.error('Error eliminando comentario', err);
      }
    });
}
cancelDelete() {
  this.showDeleteDialog = false;
  this.deleteTarget = null;
}

  // =========================
  // LABEL HELPER
  // =========================
  getNetworkLabel(network?: string): string {
    if (!network) return 'Desconocida';
    return this.networkLabels[network] || network;
  }
}